import "bootstrap";
import "./jquery";
import "./fontawesome";
import 'tippy.js/themes/light-border.css';
import tippy from "tippy.js";

$(document).ready(function() {
  $(".navbar-toggler").click(function(event) {
    event.preventDefault();
    $(this)
      .children()
      .toggleClass("fa-bars fa-times");
    $("html").toggleClass("menu-open");
    $(this)
      .next()
      .fadeToggle();

    if ($("html").hasClass("menu-open")) {
      $("#map").fadeOut(500);
    } else {
      $("#map").show();
    }
  });
});

tippy('[data-toggle="popover"]', {
  theme: 'light-border'
})
